import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_InputTip = _resolveComponent("InputTip")!

  return (_openBlock(), _createBlock(_component_InputTip, {
    class: "password-validation-tip",
    "offset-skid": "117",
    "arrow-padding": "160"
  }, {
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validations, (item) => {
        return (_openBlock(), _createElementBlock("p", {
          key: item.id,
          class: "password-validation-tip__item"
        }, [
          (item.isValid)
            ? (_openBlock(), _createBlock(_component_CheckIcon, {
                key: 0,
                class: "password-validation-tip__icon"
              }))
            : (_openBlock(), _createBlock(_component_CloseIcon, {
                key: 1,
                class: "password-validation-tip__icon"
              })),
          _createTextVNode(" " + _toDisplayString(item.title), 1)
        ]))
      }), 128))
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }))
}